const adminPrinterRouter = [
  {
    path: '/admin/printer',
    name: 'AdminPrinterIndex',
    component: () => import('@/views/admin/printer/index')
  }
]

export default adminPrinterRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/printer.js